import { mapGetters } from "vuex"
import ActionButton from '../ActionButton';
export default {
  name: 'PaymentSuccessModal',
  components: { ActionButton },
  props: ["success",],
  data () {
    return {
      amountPaid: undefined
    }
  },
  computed: {
    ...mapGetters(['isV2User'])

  },
  mounted () {
    this.amountPaid = localStorage.getItem("txnAmount")
    setTimeout(() => {
      localStorage.removeItem("txnString");
      localStorage.removeItem("txnAmount");
      localStorage.removeItem("paymentQuery");
      if (this.isV2User) {
        if (this.success) {
          this.$store.dispatch("storeMixpanelEvent", {
            eventName: "REPAYMENT_ATTEMPT_COMPLETED",
            propertyName: "STATUS",
            propertyValue: "SUCCESS"
          });
        }
        else {
          this.$store.dispatch("storeMixpanelEvent", {
            eventName: "REPAYMENT_ATTEMPT_COMPLETED",
            propertyName: "STATUS",
            propertyValue: "FAILURE"
          });
        }
        this.$router.push({ name: 'Dashboard' })
      }
      else {
        this.$router.push({ name: 'Home' })
      }
    }, 3000)
  },
  methods: {
    redirect () {
      if (this.success) {
        this.$router.push({ name: "Home" })
      }
      else {
        this.$router.push({ name: "PaymentType" })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PaymentSuccessModal/component.js